module.exports = __webpack_public_path__ + "img/dcd1d89a88e9f7f94cb41748deb3adfd.37a3de28.svg";